import axiosInstance from './axios';

export const diaryService = {
  getAllEntries: () => axiosInstance.get('/api/diary'),
  getEntry: (id) => axiosInstance.get(`/api/diary/${id}`),
  createEntry: (data) => axiosInstance.post('/api/diary', data),
  updateEntry: (id, data) => axiosInstance.put(`/api/diary/${id}`, data),
  deleteEntry: (id) => axiosInstance.delete(`/api/diary/${id}`),
  getDailyEntry: (date) => axiosInstance.get(`/api/diary/daily/${date}`)
};
